import { IPartyNumberMap } from '../models/TypeHelper'
import { IRegionalPollMap } from '../App'
import { processResultKey } from '../controllers/ElectionResultStore'
import PartyResultMap from '../models/PartyResultMap'

export type PredictionModel = 'deterministic' | 'randomized'
export type PollsToShow = 'nationalSlider' | 'regionalSliders'
export type ResultDisplayMode =
  | 'geographicalMap'
  | 'tables'
  | 'insights'
  | 'legislature'
export interface IMapLocation {
  lat: number
  lng: number
  zoom: number
}

export interface IReduxState {
  baseResultKey: string
  compareResultKey: string
  rawPolls: IPartyNumberMap | IRegionalPollMap
  predictionModel: PredictionModel
  resultDisplayMode: ResultDisplayMode
  lastReset: number
  mapLocation: IMapLocation
  outcomes: PartyResultMap[]
  outcomesToGenerate: number
}

export interface IReduxAction {
  type: string
  baseResultKey?: string
  compareResultKey?: string
  predictionModel?: PredictionModel
  mapLocation?: IMapLocation
  resultDisplayMode?: ResultDisplayMode
  polls?: IPartyNumberMap | IRegionalPollMap
  overwriteResult?: boolean
}
export interface IResultKeysProps {
  baseResultKey: string
  compareResultKey: string
  lastReset: number
}

export const mapResultKeysToProps = (state: IReduxState): IResultKeysProps => ({
  baseResultKey: state.baseResultKey,
  compareResultKey: state.compareResultKey,
  lastReset: state.lastReset
})

export const generateResultKey = (baseKey: string): string => {
  const processedKey = processResultKey(baseKey)
  return `${processedKey}#${new Date().getTime()}`
}
